<template>
  <crud-list
    :datasource="datasource"
    :capabilities="capabilities"
    :callRefresh="callRefresh"
    ref="datasourceRef"
  >
    <template #search>
      <v-combobox
        v-model="etatBilan"
        :items="enums.etatBilan"
        item-text="label"
        item-value="id"
        :append-icon="''"
        :label="$t('bilansCorrespondant.search.etatBilan')"
        @input="inputEventBilan"
        :clearable="true"
        @click:clear="inputEventBilan"
      />
      <v-flex>
        <date-picker
          ref="search"
          :label="$t('bilansCorrespondant.search.dateDebutBilan')"
          v-model.trim="dateDebut"
          :date-formatter="dateFormatter"
          :close-on-content-click="false"
          append-icon="search"
          :validator="$v.dateDebut"
          @change="inputEvent"
        />
      </v-flex>
      <v-flex>
        <date-picker
          ref="search"
          :label="$t('bilansCorrespondant.search.dateFinBilan')"
          v-model.trim="dateFin"
          :date-formatter="dateFormatter"
          :close-on-content-click="false"
          append-icon="search"
          :validator="$v.dateFin"
          @change="inputEvent"
        />
      </v-flex>
      <v-tooltip bottom>
        <template #activator="data">
          <v-btn
            fab
            small
            color="primary"
            v-on="data.on"
            @click="exportExcelParticipantBilan()"
            :loading="loading"
          >
            <v-icon color="white">fa-file-excel</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('adherents.tooltip.export') }}</span>
      </v-tooltip>
    </template>
    <template #table>
      <datasource-table :datasource="datasource">
        <template #item="{ item }">
          <tr>
            <td>
              {{ item.id }}
            </td>
            <td>
              {{ item.name }}
            </td>
            <td>
              {{ dateFormatter(item.dateBilan) }}
            </td>
            <td>
              {{ dateFormatter(item.dateClotureN) }}
            </td>
            <td>
              {{ dateFormatter(item.dateFacturation) }}
            </td>
            <td>
              {{ item.etatBilan }}
            </td>
          </tr>
        </template>
      </datasource-table>
    </template>
  </crud-list>
</template>

<script>
import Datasource from '@/utils/datasource'
import DateFormatter from '@/plugins/mixins/DateFormatter'
import { required } from 'vuelidate/lib/validators'
import { minDateOrEqual } from '@/utils/validators'
import CSVMixin from '@/plugins/mixins/CSVMixin'

export default {
  mixins: [DateFormatter, CSVMixin],
  props: {
    fieldName: {
      type: String,
      default: '_link',
    },
    capabilities: {
      type: String,
      default: 'search',
    },
    rowsSize: {
      type: Number,
      default: 15,
    },
    callRefresh: {
      type: Boolean,
      default: true,
    },
  },
  mounted() {
    this.$nextTick(function () {
      // this.datasource.args.idTechnique = this.$auth.idTechnique();
      this.datasource.refresh()
    })
  },
  data() {
    const datasource = new Datasource('bilansCorrespondant', {
      page: 1,
      rowsPerPage: this.rowsSize,
      sortBy: 'dateClotureN',
      descending: false,
      args: {},
      customRowClass: (item) => (item.actif ? '' : 'inactive-item'),
      linkClass: (item) => (item.actif ? '' : 'inactif'),
      fields: [
        {
          value: 'id',
          text: this.$t('adherents.bilans.list.headers.id'),
          sortable: true,
        },
        {
          value: 'name',
          text: this.$t('adherents.bilans.list.headers.name'),
          sortable: true,
        },
        {
          value: 'dateBilan',
          text: this.$t('adherents.bilans.list.headers.datePremierRDV'),
          sortable: false,
        },
        {
          value: 'dateClotureN',
          text: this.$t('adherents.bilans.list.headers.dateCloture'),
          sortable: true,
        },
        {
          value: 'dateFacturation',
          text: this.$t('adherents.bilans.list.headers.dateFacturation'),
          sortable: true,
        },
        {
          value: 'etatBilan',
          text: this.$t('adherents.bilans.list.headers.etatBilan'),
          sortable: false,
        },
      ],
    })
    const aujourdhui = new Date().toISOString().slice(0, 10)
    const i = new Date().setFullYear(new Date().getFullYear() - 1)
    const anneeDerniere = new Date(i).toISOString().slice(0, 10)
    datasource.args.dateDebut = anneeDerniere
    datasource.args.dateFin = aujourdhui

    return {
      datasource,
      dateFin: aujourdhui,
      dateDebut: anneeDerniere,
      etatBilan: null,
      enums: {
        etatBilan: ['En cours', 'Cloturé', 'Facturé'],
      },
      loading: false,
    }
  },
  methods: {
    emitsearchby(attr, value) {
      this.datasource.args[attr] = value
    },

    inputEvent() {
      this.$v.dateDebut.$touch()
      this.$v.dateFin.$touch()
      if (!this.$v.dateDebut.$error && !this.$v.dateFin.$error) {
        this.datasource.args.dateDebut = this.dateDebut
        this.datasource.args.dateFin = this.dateFin
        this.datasource.refresh()
      }
    },

    inputEventBilan() {
      if (this.etatBilan) {
        this.datasource.args.etatBilan = this.etatBilan
      } else {
        this.datasource.args.etatBilan = null
      }
      this.datasource.refresh()
    },

    exportExcelParticipantBilan() {
      return this.downloadFile(
        '/excel-participant-bilan',
        'historique-bilan_' + this.dateDebut + '_' + this.dateFin + '.xls',
        this.datasource.args,
        'arraybuffer',
      )
    },
  },
  validations() {
    return {
      dateDebut: {
        required,
      },
      dateFin: {
        required,
        minDateOrEqual: minDateOrEqual(this.dateDebut),
      },
    }
  },
}
</script>
